<template>
	<div>
		<v-row>
			<v-col cols="12" class="font-type text-left headline"> {{ title }} </v-col>
			<v-col>
				<v-chip-group column class="p-0" @change="setPlacesSelected">
					<v-chip filter value="all" color="accent" class="ma-1">
						<v-avatar left class="accent darken-4">{{ places.length }}</v-avatar>
						Todos
					</v-chip>
					<v-chip
						filter
						value="created"
						color="success"
						class="ma-1"
						v-if="myOwnedPlaces.length"
					>
						<v-avatar left class="success darken-4">
							{{ myOwnedPlaces.length }}
						</v-avatar>
						Creado
					</v-chip>
					<v-chip
						filter
						value="shared"
						color="info"
						class="ma-1"
						v-if="mySharedPlaces.length"
					>
						<v-avatar left class="info darken-4">
							{{ mySharedPlaces.length }}
						</v-avatar>
						Compartido
					</v-chip>
				</v-chip-group>
				<places-document-chip :chips-list="chipsList" :onChangeChips="onChangeChips" />
				<div class="warning--text caption text-left">{{ warningMessage }}</div>
			</v-col>
		</v-row>
		<div v-if="places.length" class="maxHeightListPlace">
			<v-list two-line class="backgroundTransparent">
				<template v-for="item in placesSelected">
					<place-item :key="item._id + title" :item="item" />
				</template>
			</v-list>
		</div>
		<v-card flat v-if="!places.length" height="60" class="text-center">
			<v-card-text class="headline">
				<v-icon large left>mdi-account-circle</v-icon>{{ msjnodata }}
			</v-card-text>
		</v-card>
	</div>
</template>

<script>
export default {
	name: 'PlaceList',
	components: {
		PlaceItem: () => import('@/components/place/PlaceItem.vue'),
		placesDocumentChip: () => import('@/components/place/PlaceDocumentChip.vue'),
	},
	props: {
		title: { type: String, default: () => '' },
		msjnodata: { type: String, default: () => '' },
		places: { type: Array, default: () => [] },
		mySharedPlaces: { type: Array, default: () => [] },
		myOwnedPlaces: { type: Array, default: () => [] },
		chipsList: { type: Array, default: () => [] },
		onChangeChips: { type: Function, required: true },
		warningMessage: { type: String, default: '' },
	},
	data() {
		return {
			placesSelected: [],
		};
	},
	mounted() {
		this.setPlacesSelected();
	},
	methods: {
		setPlacesSelected(value) {
			switch (value) {
				case 'created':
					this.placesSelected = this.myOwnedPlaces;
					break;
				case 'shared':
					this.placesSelected = this.mySharedPlaces;
					break;
				case 'all':
					this.placesSelected = this.places;
					break;
				default:
					this.placesSelected = this.places;
					break;
			}
		},
	},
	watch: {
		places() {
			this.setPlacesSelected();
		},
	},
};
</script>
<style media="screen">
.maxHeightListPlace {
	max-height: 500px;
	overflow-y: auto;
}
</style>
